import {IAttributes, IAugmentedJQuery, IDirective, INgModelController, IQService, IScope} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";
import {Throttle} from "../tjenester/Throttle";
import {BrukerRessurs} from "../tjenester/ressurser/BrukerRessurs";
import _ from "lodash";

export function validerEpostOppdateresTilForInjisering() {
    return [regNavn.ng.$q, Throttle.regNavn, BrukerRessurs.regNavn, validerEpostOppdateresTil];
}

/**
 * Validerer brukernavn vhja brukerRes.validerEpostOppdateresTil(..).
 *
 * Eksponerer feilkoden 'epost_ibruk' under NgModelController.$error
 * Eksponerer feilkoden 'ugyldig_format' under NgModelController.$error
 */
export function validerEpostOppdateresTil($q: IQService, throttle: Throttle, brukerRes: BrukerRessurs): IDirective {

    return {
        restrict: "A",
        require: 'ngModel',
        link: function ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes, $ctrl: INgModelController) {

            var throttledValider = throttle.throttle(
              (_epost, $scope, $ctrl: INgModelController) => {
                  brukerRes.validerEpostOppdateresTil({
                      brukerId: $scope.$eval($attr['validerEpostOppdateresTil']),
                      epost: _epost
                  }).$promise
                    .then(resultat => {
                        $ctrl.$setValidity('i_bruk', !_.includes(resultat.feilkoder, 'i_bruk'))
                        $ctrl.$setValidity('email', !_.includes(resultat.feilkoder, 'ugyldig_format'))
                    });
              },
              1000);

            // bruker ikke $ctrl.$asyncValidators da vi ønsker å throttle serversidevalideringskallet og det
            // spiller ikke bra med semantikken til $ctrl.$asyncValidators
            // $viewChangeListeners vil ikke bli kalt før øvrige registrerte validatorer er OK
            // dog ser $viewChangeListeners ut til å bli ifbm første kjøring av øvrige validatorer
            $ctrl.$viewChangeListeners.push(() => {
                var epost = $ctrl.$viewValue;
                if ($ctrl.$error && $ctrl.$error.email) return; //forhindrer kjøring hvis angular validering av epost ikke er gyldig
                if ($ctrl.$error && $ctrl.$error.requiered) return; //forhindrer kjøring hvis angular validering av epost ikke er gyldig
                throttledValider(epost, $scope, $ctrl);
            });

        }
    };
}
